import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

//搜索表单
import SearchForm from "@/components/form";
import SearchFormTwo from "@/components/form/form_model";
import Pagination from "@/components/pages";
import dTable from "@/components/table";

//富文本编辑
import VueUeditorWrap from "vue-ueditor-wrap";
Vue.component("VueUeditorWrap", VueUeditorWrap);

import { get, post } from "@/apis";

Vue.use(ElementUI);

//分页
Vue.component("Pagination", Pagination);

//全局挂在form表单组件
Vue.component("SearchForm", SearchForm);
//弹窗表单组件
Vue.component("SearchFormTwo", SearchFormTwo);

//全局挂载table组件
Vue.component("dTable", dTable);
if (process.env.NODE_ENV === "production") {
  // 禁用所有调试日志，保留error
  console.log = function () {};
  console.info = function () {};
  console.warn = function () {};
  console.debug = function () {};
}
Vue.prototype.$https = { get: get, post: post };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
